import * as React from 'react';

import { DataItem } from '../DataItem';

interface IStatusProps {
  status: string;
}

export const ResidentialStatus: React.FC<IStatusProps> = ({ status }) => {
  return <DataItem header="Статус помещений" text={status} />;
};
